module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "text-xs-center"
  }, [_c('vimeo-player', {
    ref: "player",
    attrs: {
      "video-id": _vm.videoID,
      "player-height": _vm.height
    },
    on: {
      "ready": _vm.onReady
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-082a74f1","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/shared/what-is-braster/what-is-braster.vue
// module id = 1156
// module chunks = 0